<div class="section">
  <div class="section-content">
      <h1>Becoming a supplier</h1>
      <p>SpaceX is committed to including diverse suppliers in our sourcing process, which enhances our ability to 
        provide the most reliable, high-quality, and cost-effective products and services.</p>
      <p>While SpaceX develops and manufactures its technologies and products in-house, often times we can leverage 
        specialized, small, nimble, or local suppliers that enable us to achieve our goals.</p>

      <div class="buttons">
        <div>
          <p>Interested in doing business with us?</p>
          <spx-button text="Become a supplier" url="/supplier/submit" marginTop="0"></spx-button>
        </div>
        <div>
          <p>Already a supplier?</p>
          <spx-button text="Sign in" url="https://supplierportal.spacex.com/" marginTop="0"></spx-button>
        </div>
      </div>
  </div>
</div>